import axios from '../utils/index';

/**
 * Marketplace task acceptances waiting on an admin. When a tasker accepts a marketplace task the
 * backend records a request instead of assigning the task; nothing starts until an admin approves.
 * Matches the Java `TaskController` endpoints under `/task/accept-requests`.
 *
 * Snowflake IDs travel as strings to avoid JavaScript precision loss.
 */
const taskAcceptRequestsApi = {
    /** All pending requests, oldest task first as the backend orders them. */
    async getPending() {
        return axios.get(`/task/accept-requests`);
    },

    /** Assign the task to this tasker; the backend auto-declines the other requests for it. */
    async approve(taskId: string, taskerId: string) {
        return axios.post(`/task/${taskId}/accept-requests/${taskerId}/approve`);
    },

    /** Decline one tasker's request; the task keeps looking for a tasker. */
    async decline(taskId: string, taskerId: string, reason?: string) {
        return axios.post(`/task/${taskId}/accept-requests/${taskerId}/decline`, null, {
            params: reason ? { reason } : {},
        });
    },
};

export default taskAcceptRequestsApi;
